export default "__VITE_ASSET__7acabcd3__"